import request from '@/utils/request'
export function GetWxLoginUrl(url) {
  return request({
    url: '/user/GetWxLoginUrl',
    method: 'get',
    params: { url }
  })
}

export function getSSIBaseData() {
  return request({
    url: '/data/getSSIBaseData',
    method: 'post'
  })
}

export function getEnumList() {
  return request({
    url: '/data/getEnumList',
    method: 'post'
  })
}
